import { postData } from '../utils/ajax-utils';
import { ModalHTMLElement } from '../components/modal';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initRetrievePassword(): void {
    const $buttonRetrievePassword = document.querySelectorAll<HTMLElement>('.js-retrieve-password');
    $buttonRetrievePassword.forEach($container => {
        new RetrievePassword($container);
    });
}

class RetrievePassword {
    $el: HTMLElement | null | undefined;
    $modalSuccess;
    $modalError;
    
    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$modalSuccess = document.querySelector<ModalHTMLElement>('[data-modal-id="modal-retrieve-password-success"]');
        this.$modalError = document.querySelector<ModalHTMLElement>('[data-modal-id="modal-retrieve-password-error"]');
        this.init();
    }

    init(): void {
        this.$el?.addEventListener('click', () => {
            postData(script_var.ajax_url, {action: 'ajax_retrieve_password'}).then(response => {
                if (response.success) {
                    this.$modalSuccess?.open();
                } else {
                    this.$modalError?.open();
                }
            });
        });
    }
}
